import { Action } from '@ngrx/store';

import { UploadItem } from '@common/entities/uploads/upload-item.entity';

export enum UploadActionTypes {
    Add = '[Uploads] Add',
    Update = '[Uploads] Update',
    Remove = '[Uploads] Remove'
}

export class AddUploadItem implements Action {
    readonly type: UploadActionTypes.Add = UploadActionTypes.Add;
    constructor(public uploadItem: UploadItem) {}
}

export class UpdateUploadItem implements Action {
    readonly type: UploadActionTypes.Update = UploadActionTypes.Update;
    constructor(public id: string, public changes: Partial<UploadItem>) {}
}

export class RemoveUploadItem implements Action {
    readonly type: UploadActionTypes.Remove = UploadActionTypes.Remove;
    constructor(public id: string) {}
}

export type UploadActions = AddUploadItem | RemoveUploadItem | UpdateUploadItem;
